import { composeEmail as composeEmailBase } from '../../../common/utils/composeEmail';
import log from '../../../common/utils/logger';

/**
 * Composes and opens an email in the user's default email client
 * @param {Object} options - Email composition options
 * @param {string[]} options.to - Array of recipient email addresses
 * @param {string[]} options.bcc - Array of BCC recipient email addresses
 * @param {string} options.subject - Email subject line
 * @param {string} options.body - Email body content
 */
export const composeEmail = ({
  to = [], bcc = [], subject = '', body = '',
}) => {
  composeEmailBase({
    to, bcc, subject, body,
  }).catch((err) => {
    log.error('Failed to open email client:', err);
  });
};

export { composeEmailBase };

/**
 * Generates email subject for a slot session
 * @param {Object} slot - Slot information
 * @param {string} eventKindLabel - Label for the event kind
 * @param {string} moduleTitle - Module title
 * @param {string[]} taskTitles - Array of task titles
 * @returns {string} Formatted email subject
 */
export const generateSlotEmailSubject = (slot, eventKindLabel, moduleTitle, taskTitles = []) => {
  const parts = [eventKindLabel];

  if (moduleTitle) {
    parts.push(moduleTitle);
  }

  if (taskTitles.length > 0) {
    if (taskTitles.length === 1) {
      parts.push(taskTitles[0]);
    } else {
      parts.push(taskTitles.join(', '));
    }
  }

  return parts.join(' - ');
};

/**
 * Generates email body with slot details
 * @param {Object} slot - Slot information
 * @param {string} eventKindLabel - Label for the event kind
 * @param {Function} formatDate - Function to format date
 * @param {Function} formatTime - Function to format time
 * @returns {string} Formatted email body
 */
export const generateSlotEmailBody = (slot, eventKindLabel, formatDate, formatTime) => {
  const date = formatDate(slot.startTime);
  const startTime = formatTime(slot.startTime);
  const endTime = formatTime(slot.endTime);

  return `${eventKindLabel}\n${date}\n${startTime} - ${endTime}\n\n`;
};
